import { render, staticRenderFns } from "./TransformaApresentacao.vue?vue&type=template&id=77dda564&scoped=true&"
import script from "./TransformaApresentacao.vue?vue&type=script&lang=js&"
export * from "./TransformaApresentacao.vue?vue&type=script&lang=js&"
import style0 from "./TransformaApresentacao.vue?vue&type=style&index=0&id=77dda564&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77dda564",
  null
  
)

export default component.exports